import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AdminService } from '../../_services/admin.service';
import { HeaderData } from 'src/app/_models/header-data';
import { FORM_MSGS, ADMIN_UTILITY, PROFILE_OPTIONS, PRODUCT_CONFIG } from 'src/app/_common/product-config';
import { ActivatedRoute, Router } from '@angular/router';
import { DiceInfo } from '../_models/company-data';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyType, Modules, StatusCode } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.scss']
})
export class EditCompanyComponent implements OnInit {

  @ViewChild("editCompanyForm", {static: false}) editCompanyForm: NgForm;
  @ViewChild("PermWarnModal", {static: false}) PermWarnModal;
  
  //Edit HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private companyDetails;
  private companyId = null;
  
  private allCompanyType;
  private selectedCompanyType;
  
  private allCompanyStatus = [
    {displayName: "Active", value: 1},
    {displayName: "Deactivated", value: 2}
  ];
  private selectedCompanyStatus = this.allCompanyStatus[0];
  private loading: boolean = false;
  private updating: boolean = false;
  private deactivating: boolean = false;

  private canDeactivate: boolean = true;

  private errorMessage:string = '';
  private successMessage:string = '';
  private warningMessage:string = '';
  private productConfig = PRODUCT_CONFIG;
  private formMsgs = FORM_MSGS;
  private adminMsgs = ADMIN_UTILITY;

  private isDiceCompany: boolean = false;
  private hasAccess:boolean = false;
  private allPermSelected:boolean = false;
  
  //private killServicesOnDestroy = [];
  private borSkipSelected:boolean = false;
  
  private modalReference;
  private warningModalPerm:string;
  private warnPerms = [{moduleName: Modules.BORSkip, isSelected:false}];
  private warnPerm:any;

  @ViewChild("deactivateCompanyModal", {static: false}) deactivateCompanyModal;
  constructor(private readonly route: ActivatedRoute, private router: Router, private adminService: AdminService, private modalService : NgbModal) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.route.paramMap.subscribe(params => {
      this.companyId = params.get("id").toString();
      this.fetchCompanyDetails();
    });
  }

  get allProfileOptions(){
    return PROFILE_OPTIONS;
  }

  setHeaderData(){
    this.headerData.pageTitle = "Edit Company";
    this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];
    if(this.companyDetails){
      this.headerData.breadcrumb.push({itemName: this.companyDetails.companyName, itemLink: "/admin/company/"+ this.companyDetails.companyID})
    }
    this.adminService.header = this.headerData;  
  }

  fetchCompanyDetails(){
    this.loading = true;
    let companyDetailsSubscription = this.adminService.fetchCompanyDetails(this.companyId).subscribe((company:any)=>{
      //this.loading = false;
      this.hasAccess = true;
      this.companyDetails = company;
      if(this.companyDetails != null){
        this.setHeaderData();
        let producerCodes = this.companyDetails.producerCodes;//.split(",").map(Number);
        
        let newProducerCodes = [];
        producerCodes.forEach(_producerCode => {
          newProducerCodes.push({code: _producerCode, isSelected: true});
        });
        
        this.companyDetails.producerCodesArray = newProducerCodes;
        this.companyDetails.permissions.forEach((p:any)=>{
          if(p.moduleName == Modules.BORSkip && p.isSelected){
            this.borSkipSelected = true;
          }
          if(p.moduleName == Modules.NBDICE && p.isSelected){
            this.isDiceCompany = true;
          }
        });
        this.getCompanyConfig();
        if(!this.companyDetails.diceInfo) this.companyDetails.diceInfo = new DiceInfo;
      }
    },error=>{
      this.loading = false;
      this.companyDetails = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.adminService.runningServices.push(companyDetailsSubscription);
  }

  getCompanyConfig(){
    this.loading = true;
    let companyConfigSubscription = this.adminService.getCompanyConfig().subscribe(response => {
      this.loading = false;
      if(response) {
        this.allCompanyType = response.companyTypes;
        this.selectCompanyType(this.companyDetails.typeID);
        this.allPermSelected = this.companyDetails.permissions.length == response.companyPermissions.length;
        let warnList = [];
        let permList = [];
        response.companyPermissions.forEach(p => {
          let warnMatch = this.warnPerms.find((perm) => perm.moduleName == p.moduleName);
          if(warnMatch){
            let permMatch = this.companyDetails.permissions.find((perm) => perm.moduleName == p.moduleName);
            if(permMatch){
              warnList.push(permMatch);
            }
            else{
              warnList.push(p);
            }
          }
          else{
            let permMatch = this.companyDetails.permissions.find((perm) => perm.moduleName == p.moduleName);
            if(permMatch)
            {
              p.isSelected = permMatch.isSelected;
            }
            permList.push(p);
          }
        });
        this.warnPerms = warnList;
        this.companyDetails.permissions = permList;
      } else {
        this.warningMessage = this.adminMsgs.AdminConfigError;
      }
    },
    error => {
        this.errorMessage = this.formMsgs.SomethingWentWrong;
        this.loading = false;
    });
    this.adminService.runningServices.push(companyConfigSubscription);
  }

  selectCompanyType(_companyTypeId){
    this.selectedCompanyType = this.allCompanyType.find((_type)=>{return _type.typeID == _companyTypeId});
    this.companyDetails.typeID = this.selectedCompanyType.typeID;
    this.companyDetails.typeDesc = this.selectedCompanyType.typeDesc;
  }
  updatePermNode(permNode){
    if(permNode.moduleName == Modules.NBDICE){
      this.isDiceCompany = permNode.isSelected;
      if(!this.companyDetails.diceInfo){
          this.companyDetails.diceInfo = new DiceInfo;
      }
    }
  }

  openPermWarningModal(permNode:any){
    permNode.isSelected = !permNode.isSelected;
    this.warningModalPerm = permNode.displayName;
    this.warnPerm = permNode;
    if(permNode.moduleName == Modules.BORSkip){
      this.borSkipSelected = permNode.isSelected;
    }
    //console.log("preopen", permNode);
    if(permNode.isSelected){
      this.modalReference = this.modalService.open(this.PermWarnModal, { centered: false, backdropClass: 'light-blue-backdrop' });
      this.modalReference.result.then((result) => {
        permNode.isSelected = true;
        
        //console.log("closed", result, permNode);
      }, (reason) => {
        //Dismissed
        permNode.isSelected  = false;
        this.borSkipSelected = false;
        //console.log("dismiss", reason, permNode);
      });
    }
  }
  addDiceSection(){
    if(this.companyDetails.diceInfo == null){this.companyDetails.diceInfo = new DiceInfo;}
  }

  addProducerCode(addedProducerCode){
    if(this.companyDetails.producerCodes.indexOf(addedProducerCode) < 0 && addedProducerCode != ''){
      this.companyDetails.producerCodes.push(addedProducerCode);
    }
  }

  removeProducerCode(_index){
    this.companyDetails.producerCodes.splice(_index, 1);
  }

  updateCompany() {
    this.resetAlertMessages();
    if(this.editCompanyForm.valid && (this.companyDetails.producerCodes.length > 0 || this.borSkipSelected)){
      this.updating = true;
      this.loading = true;
      this.warnPerms.forEach((p:any) =>{
        if(p.isSelected){
          this.companyDetails.permissions.push(p);
        }
      });

      let editCompanySubscription = this.adminService.updateCompany(this.companyDetails).subscribe((result:any) => {
        this.updating = false;
        this.loading = false;
        this.router.navigate(['admin/company/' + this.companyDetails.companyID], 
        {state: {newBusinessError: result.permissionErrors.newBusiness, endtError: result.permissionErrors.endt, renewalError: result.permissionErrors.renewal}});
      },
      error => {
          this.errorMessage = this.formMsgs.SomethingWentWrong;
          this.updating = false;
      });
      this.adminService.runningServices.push(editCompanySubscription);
    }
  }
  selectAllPerm(){
    this.companyDetails.permissions.forEach((n:any) => {
      if(n.moduleName != Modules.BORSkip){
        n.isSelected = this.allPermSelected;
      }
    });
    this.isDiceCompany = this.allPermSelected;
  }
  onDeactivate(){
    this.modalReference = this.modalService.open(this.deactivateCompanyModal, { centered: false, backdropClass: 'light-blue-backdrop' });
    this.modalReference.result.then((result) => {
      console.log("closed");
      }, (reason) => {
        console.log("dismissed");
    });
  }

  deactivateCompany() {
    this.resetAlertMessages();
    if(this.canDeactivate){
      this.modalReference.close();
      this.deactivating = true;
      let deactivateCompanySubscription = this.adminService.deactivateCompany(this.companyDetails).subscribe(data => {
        this.deactivating = false;
        this.router.navigate(['admin/company/' + this.companyDetails.companyID]);
      },
      error => {
          this.errorMessage = this.formMsgs.SomethingWentWrong;
          this.deactivating = false;
      });
      this.adminService.runningServices.push(deactivateCompanySubscription);
    }
  }

  resetAlertMessages(){
    this.errorMessage = "";
    this.successMessage = "";
    this.warningMessage = "";
  }

  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
